import api from 'lib/CfcLmsApi'
import documentServiceApi from 'lib/DocumentServiceApi'
import { actions } from './reducer'
import { addNotification } from 'store/notifications'
import { createTrainingReportDownloadData } from './selector'

export const fetchLessonProgressReport = (siteId, skuCode) => {
  return async dispatch => {
    dispatch(actions.fetchingReport(skuCode))
    try {
      const programCode = skuCode === 'K8P' ? 'K8' : 'HS'
      const response = await documentServiceApi.post('/SiteReport', {
        siteId,
        program: programCode,
        options: {
          useFlexTemplate: true,
          useHsFullTemplate: true,
        },
      })
      const sasUrl = response.data.sasUrl
      dispatch(actions.fetchingReportSuccess({ program: skuCode, reportData: sasUrl }))
    } catch (error) {
      dispatch(actions.fetchingReportError({ error, program: skuCode }))
      dispatch(
        addNotification({
          color: 'danger',
          text: 'Failed to get Lesson Progress Report',
        }),
      )
    }
  }
}

export const deleteReports = () => {
  return async dispatch => {
    dispatch(actions.deleteReportsSuccess())
  }
}

export const deleteLessonProgressReport = () => {
  return async dispatch => {
    dispatch(actions.deleteReportsSuccess())
  }
}

export const fetchTrainingReport = (learners, program, siteName) => {
  return async dispatch => {
    dispatch(actions.fetchingReport(program))
    try {
      const { data: trainingReportData } = await api.getTrainingReport(
        learners,
        program.toLowerCase(),
      )
      const formattedTrainingReportData = createTrainingReportDownloadData(
        trainingReportData,
        program,
        siteName,
      )
      dispatch(
        actions.fetchingReportSuccess({
          program,
          reportData: formattedTrainingReportData,
        }),
      )
    } catch (error) {
      dispatch(actions.fetchingReportError({ error, program }))
      dispatch(
        addNotification({
          color: 'danger',
          text: error,
        }),
      )
    }
  }
}

export default {
  deleteReports,
  deleteLessonProgressReport,
  fetchLessonProgressReport,
  fetchTrainingReport,
}
